import { useTranslation } from 'react-i18next';

import { DataPanel, FaIcon } from '@/ui';
import type { Attachment } from '@/signalr';
import { openMediaViewerDialog } from '../../actions';
import { isVideoAttachment } from '@ngsos/portal-core/incidents';

export type UploadedMediaSectionProps = {
  media: readonly Attachment[];
};

export function UploadedMediaSection({ media }: UploadedMediaSectionProps) {
  const { t } = useTranslation();

  if (media.length === 0) {
    return null;
  }

  const orderedMedia = [...media].sort((a, b) => Date.parse(b.uploadedAtUtc) - Date.parse(a.uploadedAtUtc));

  return (
    <DataPanel header={t('Incident_InfoPanel_UploadedMedia_PanelHeader')}>
      <div className="uploaded-media-panel">
        {orderedMedia.map((item, index) => (
          <div
            key={item.url}
            className="uploaded-media-panel__thumbnail"
            onClick={() => openMediaViewerDialog(orderedMedia, index)}
          >
            {isVideoAttachment(item) ? (
              <div className="uploaded-media-panel__video-wrapper">
                <video src={item.url} className="uploaded-media-panel__media" muted preload="metadata"></video>
                <div className="uploaded-media-panel__play-overlay">
                  <FaIcon icon="fa-solid fa-circle-play" />
                </div>
              </div>
            ) : (
              <img src={item.url} alt="Attachment" className="uploaded-media-panel__media" loading="lazy" />
            )}
          </div>
        ))}
      </div>
    </DataPanel>
  );
}
